import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  ControlContainer,
  FormControl,
  NG_VALUE_ACCESSOR,
  Validators,
} from '@angular/forms';
import { HttpRequest } from '../../models';
import { Observable } from 'rxjs';
import { HttpProviderService } from '../../services';
import { BaseFpxControlComponent } from '@fpx/core';
import { FPXFakeFileUploadService } from '../../services/file-upload/file-upload.service';
import { DialogService } from '../../services/dialog/dialog.service';
import { CommonService } from 'src/app/common.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { WebcamImage } from 'ngx-webcam';

@Component({
  selector: 'fpx-file-upload',
  templateUrl: './fpx-file-upload.component.html',
  styleUrls: ['./fpx-file-upload.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FpxFileUploadComponent),
      multi: true,
    },
  ],
})
export class FpxFileUploadComponent extends BaseFpxControlComponent {
  // New Variables Start
  @Input('acceptFormat') acceptFormat: any = ['image/png', 'image/jpeg', 'image/jpg', 'application/pdf'];

  @Input() minSize: any;
  @Input() maxSize: any = 5000000; //size in bytes
  @Input() extensions: any = '';

  @Input() uploadOnBrowse: boolean = true;
  @Input() serviceCall: boolean = true;

  @Input() mode: any = 'A';
  @Input() maxFilesCount: number = 10;
  @Input() documentType: string;
  @Input() parentDocType: string;
  @Input() isReadonly: boolean = false;
  @Input() nameofDoc: string;
  private _errormsg: any;

  @Input() 
  set errormessage (msg: any) {
    this._errormsg = msg;
    this.checkMinFileRequired();
  }
  get errormessage (): any { return this._errormsg };
  uploadTitle: string;
  cameraBob?: any;

  private  _minFilesCount: number;
	@Input() 
	set minFilesCount(val: number){
		this._minFilesCount =val;
    this.checkMinFileRequired();
	}
	get minFilesCount():number{
		return this._minFilesCount;
	}

  private _patchFiles:any;
  /** Avoid repeated `/documentdownload/{inv}` when `patchFiles` is reassigned with the same invoice numbers. */
  private _lastPatchFilesDownloadSignature: string | null = null;

  private buildPatchFilesDownloadSignature(val: any): string {
    if (val == null || val === "") {
      return "";
    }
    const arr = Array.isArray(val) ? val : [val];
    if (arr.length === 0) {
      return "";
    }
    const nums = arr
      .map((x: any) => String(x?.invNumber ?? x?.docInvNum ?? "").trim())
      .filter((s) => s.length > 0)
      .sort()
      .join(",");
    return nums;
  }

  @Input() 
	set patchFiles(val: any){
		this._patchFiles =val;
    const sig = this.buildPatchFilesDownloadSignature(val);
    if (sig === this._lastPatchFilesDownloadSignature) {
      this.checkMinFileRequired();
      return;
    }
    this._lastPatchFilesDownloadSignature = sig;
    this.patchFilesToView(val);
    this.checkMinFileRequired();
	}
	get patchFiles():any{
		return this._patchFiles;
	}
  
  fileName: any = '';
  fileType: any = '';
  uploadProgress: any = 0;
  uploadSub: any;
  formData!: FormData;
  imageAsBase64: any;
  filesInvNumber = [];
  files: File[] = [];
  webcamImage: WebcamImage | undefined;
  inValidMinLength: boolean;
  // @Input() 
  _showError: boolean=false;
@Output() showErrorChange = new EventEmitter<boolean>(); // This is the standard pattern

  // Update your showError setter (or use a method)
  @Input()
  set showError(val: boolean) {
    this._showError = val;
    // Emit the change every time it is set
    this.showErrorChange.emit(val);
  }
get showError(): boolean {
  return this._showError;
}

  browseUploadVisible: boolean = true;
  // previewDeleteVisible: boolean = true;

  uploadStatus: any = '';
  touched: boolean;

  // New Variables End

  constructor(
    controlContainer: ControlContainer,
    changeDetectorRef: ChangeDetectorRef,
    private _httpProvider: HttpProviderService,
    private fileUploadService: FPXFakeFileUploadService,
    private _dialogService: DialogService,
    private dialog: MatDialog,
    protected _commonService: CommonService,
    private _router: Router
  ) {
    super(controlContainer, changeDetectorRef);
  }

  protected override doPreInit(): void {
    if(this._commonService.getApplicationMode() == 'RM') {
      this.uploadTitle = 'Upload Document'
    }
    else this.uploadTitle = 'Select';
    if(this.parentDocType == 'incomedoctype' || this.parentDocType == 'businessDocType') {
      this.checkMinFileRequired();
    }
  }

  OnChanges() {
    console.log('ModeIsChanges', this.mode);
  }

  onFileClick(event) {
    if(this._commonService.getApplicationMode() == 'RM') {
      this.touched = true;
      event.preventDefault();
      event.stopPropagation();
      let data = {
        files: this.files,
        filesInvNumber: this.filesInvNumber
      }
      this._dialogService.open({
        component: 'chooseFileUpload',
        data: data,
        panelClass: 'choose-file-upload',
        disableClose: false,
        closeFn: (res) => this.onUpload(res)
      });
      return;
    }
  }

  // New Methods Starts
  onFileSelected(event: any) {
    if(this._commonService.getApplicationMode() == 'RM') {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    const file: File = event.target.files[0];
    if (file) {
      if(this.acceptFormat.indexOf(file.type) >= 0) {
        // this.formControl.setErrors(null);
        if (file.size < this.minSize) {
          this.formControl.setErrors({InvalidMinSize: true}, { emitEvent: true });
          this.inValidMinLength = true;
        } else if (file.size > this.maxSize) {
          this.formControl.setErrors({InvalidMaxSize: true}, { emitEvent: true });
          this.showError = true;
          this.errorCode = 'Invalid file size. file size should be less than 5mb'
        } else {
          this.showError = false;
          this.inValidMinLength = false;
          this.formControl.setErrors(null);

          // this.uploadStatus = 'Success';
          this.touched = true;
          // this.files.push(file);
          if(this.uploadOnBrowse) this.onUpload(file);
        }
      }
      else {
        this.formControl.setErrors({
          InvalidFormat: true,
        });
      }
    } 
  }

  convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);

        fileReader.onload = () => {
            resolve(fileReader.result);
        };

        fileReader.onerror = (error) => {
            reject(error);
        };
    });
  };

  getImage = async (event) => {
    const file = event.target.files[0];
    const base64 = await this.convertBase64(file);
    this.onCloseDialog(base64);
  };

  onCameraFileSelected($event:any){
    this.getImage($event);
  }
  fetchDetails(payload: any): Observable<any> {
    const httpRequest = new HttpRequest();
    httpRequest.setMethod('POST');
    httpRequest.setResource('/document?documentType=PASSPORT');
    httpRequest.addHeaderParamter('Content-Type', 'multipart/form-data');
    httpRequest.setAuthTokenRequired(false);

    let bodyContent = payload;
    httpRequest.setBody(bodyContent);
    return this._httpProvider.invokeRestApi(httpRequest);
  }

  downloadFile(invNumber: any): Observable<any> {
    const httpRequest = new HttpRequest();
    httpRequest.setMethod('GET');
    httpRequest.setResource(`/documentdownload/${invNumber}`);

    let sContext = `/olive/publisher`;
    return this._httpProvider.invokeDownloadApi(httpRequest);
  }

  previewFile() {
    if(this.files.length == 0) return; 
    let data = {
      files: this.files,
      filesInvNumber: this.filesInvNumber
    }
    this._dialogService.open({
      component: 'filePreview',
      data: data,
      panelClass: 'file-preview-dialog',
      disableClose: false,
      closeFn: (res) => this.onCloseDialog(res)
    });
  }

  takeAPhotos() {
    let CBXDialogData = {
      title: 'Selfie Camera',
      message: 'Please take picture',
      button: ['Take Picture', 'ReTake', 'Continue']
    }
    this._dialogService.open({
      result: 'success',
      panelClass: ['simplecamera-dialog'],
      component: 'simplecamera',
      data: CBXDialogData,
      closeFn: (res) => this.closeDialog(res)
    })
    return
  }
  closeDialog(res): any {
    if (res) {
      this.webcamImage = res;
      this.imageAsBase64 = res;
      this.cameraBob = this._commonService.base64ToBlob(this.imageAsBase64._imageAsDataUrl);
      this.onUpload(this.cameraBob);
    }
  }

  onDelete() {
    this.reset();
  }

  reset() {
    this.uploadProgress = null;
    this.uploadSub = null;
    this.fileName = null;
    this.files = [];
    this.filesInvNumber = [];
    this.uploadStatus = '';
    this.touched = false;
    this.browseUploadVisible = true;
    // this.previewDeleteVisible = false;

    this.formControl.setValue(null, { emitEvent: true });
  }

  onUpload(file) {
    if (!file) return;
	let timeStamp = Date.now();
    if (this.documentType == 'SELFIE' && !file.name) file.name = timeStamp + '.png';
        // let file = this.files[this.files.length-1];
        this.formData = new FormData();
        this.formData.append('document', file, file.name);
        this._commonService.showSpinner();
        this.fileUploadService.upload(this.formData, this.documentType, this.parentDocType, this.nameofDoc).subscribe({
          next: (res:any) => {
            this.files.push(file);
            this.filesInvNumber.push({
              invNumber:res.body.docInvNumber,
              name: file.name,
              type: file.type
            });
            this.uploadStatus = 'Success';
            this.browseUploadVisible = false;
            this.formControl.patchValue([]);
            // this.formControl.value.length = 0;
            this.filesInvNumber.forEach(element => {
              this.formControl.value.push(element)
            });
            this.checkMinFileRequired();
            this.detectChanges();
            this._commonService.hideSpinner();
          },
          error: (reason:any) => {
            this.uploadStatus = 'Failure';
            this._commonService.hideSpinner();
            // this.previewDeleteVisible = false;
          },
        });
    // }
  }
  checkMinFileRequired() {
    if(!this.formControl) return;
    if (this.errormessage == 'secondary') {
      this.formControl.setErrors({ minCount1: true }, { emitEvent: true });
      this.showError = true;
      this.errorCode = 'Please add and upload another Secondary ID';
      this.detectChanges();
      return;
    } else if (this.errormessage == 'SErequiredIncomeDoc') {
      this.formControl.setErrors({ SErequiredIncomeDoc: true }, { emitEvent: true });
      this.showError = true;
      this.errorCode = 'Please upload one of the document from the following. Audited Financial Statements or ITR 1701.';
      return;
    } else if (this.errormessage == 'LErequiredIncomeDoc') {
      this.formControl.setErrors({ LErequiredIncomeDoc: true }, { emitEvent: true });
      this.showError = true;
      this.errorCode = 'Please upload one of the document from the following. ITR 2316 or Certificate of Employment with Compensation or Payslips (latest last 3 months).';
      return;
    } else if (this.errormessage == 'SErequiredBusDoc') {
      this.formControl.setErrors({ SErequiredBusDoc: true }, { emitEvent: true });
      this.showError = true;
      this.errorCode = 'Please upload one of the document from the following. SEC Registration or City Business Permit or Barangay Business Permit.';
      return;
    } else if (this.errormessage == 'WHrequiredBusDoc') {
      this.formControl.setErrors({ WHrequiredBusDoc: true }, { emitEvent: true });
      this.showError = true;
      this.errorCode = 'Please upload one of the document from the following. GIS (General Information Sheet) or Corporate Secretary Certificate for Top Executive Program.';
      return;
    } else if(this.errormessage == 'additionalSEBusDocReq') {
      this.formControl.setErrors({ additionalSEBusDocReq: true }, { emitEvent: true });
      this.showError = true;
      this.errorCode = 'Please upload one of the additional document from the following. SEC Registration or City Business Permit or Barangay Business Permit.';
      return;
    } else if(this.errormessage == 'additionalWHBusDocReq') {
      this.formControl.setErrors({ additionalWHBusDocReq: true }, { emitEvent: true });
      this.showError = true;
      this.errorCode = 'Please upload one of the additional document from the following. GIS (General Information Sheet) or Corporate Secretary Certificate for Top Executive Program.';
      return;
    } else{
      if(!this.showError 
      ){
      this.formControl.setErrors(null, { emitEvent: true });
      this.showError = false;
      this.errorCode = '';
      }

    }
    this.formControl?.parent.parent.updateValueAndValidity();
  }
  setConditionalError() {

  }
  @ViewChild("fileInput") fileInput: ElementRef;

  onCloseDialog(res) {
    if(res?.files?.length) {
      this.files = res?.files;
      this.filesInvNumber = res?.filesInvNumber;
      this.formControl.value.length = 0;
      this.filesInvNumber.forEach(element => {
        this.formControl.value.push(element)
      });
    }
    else {
      this.files = [];
      this.filesInvNumber = [];
      this.uploadStatus = '';
      this.fileInput.nativeElement.value = '';
      this.formControl.value.length = 0;
    }
    this.checkMinFileRequired();
    this.detectChanges();
  }

  override ngOnDestroy(): void {
    this.uploadSub?.unsubscribe();
  }

  fileSizeValidator(minSize: number, maxSize: number) {
    return (control: FormControl) => {
      const file = control.value;
      if (file) {
        const fileSize = file.size / 1024; // convert to KB
        if (fileSize < minSize) {
          return { minSize: true };
        } else if (fileSize > maxSize) {
          return { maxSize: true };
        }
      }
      return null;
    };
  }

  // New Method Ends

  override customWriteValue(data:string){
    console.log('customWriteValue',data);

    if(data){
      // this.files = null;
      // this.fileName = data;
      // this.browseUploadVisible = false;
      // this.previewDeleteVisible = true;
      
    }
  }

  patchFilesToView(obj) {
    if(obj?.length > 0) {
        this.files = JSON.parse(JSON.stringify(obj));
        this.filesInvNumber = JSON.parse(JSON.stringify(obj));
        this.formControl?.patchValue([]);
        this.filesInvNumber.forEach(element => {
          this.formControl?.value.push(element)
        });
        this.uploadStatus = 'Success';
        this.detectChanges();
        this._commonService.showSpinner();
        this.files?.forEach((element,i) => {
          this.fileUploadService.download(element['invNumber']).subscribe({
            next: (res:any) => {
              if(this.files?.length > 0) {
                this.files[i]['file'] = res.body;
                this.checkMinFileRequired();
                this.detectChanges();
                this._commonService.hideSpinner();
              }
            },
            error: (reason:any) => {
              this._commonService.hideSpinner();
            },
          });
        });
      } else {
        this.formControl?.patchValue([]);
      }
  }
  // writeValue(obj: any): void {
  //   console.log('writevalue',obj);
  //   
  // }
}
